import React from "react";

export default function SQL_Syllabus() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Syllabus</h1>
      <p>This is the SQL_Syllabus component generated from the SQL JSON.</p>
    </div>
  );
}
